import { useState } from 'react';
import { valueMatchWithQuery } from '../../../../../utils/string';
import { UseSearchableMenuListParams } from './useSearchableMenuList.types';

export const useSearchableMenuList = <T>({
  items,
  getSearchValue,
}: UseSearchableMenuListParams<T>) => {
  const [query, setQuery] = useState('');

  const visibleItems = items.filter((item) => valueMatchWithQuery(getSearchValue(item), query));

  return { query, setQuery, visibleItems };
};
